import React from "react";
import Joi from "joi-browser";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { Button, Form, Modal, Spinner, Dropdown, DropdownButton } from "react-bootstrap";
import {
  getCustomerEquipments,
  addEquipment,
  deleteEquipment,
  changeBillingCycle,
  getBillingCycles,
} from "../services/equipmentService";
import { getRouters } from "../services/routerService";
import { getPonOLTsByRouter, getPonOLTById } from "../services/ponOLTService";
import { getOntOpticalInfo, getOntWanInfo, getOntInfo, restartOnt, addOnt, deleteOnt } from "../services/ponOLTSSHService";
import FormComponent from "./common/formComponent";
import FloatingAddButton from "./common/floatingAddButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import PageLoading from "./common/pageLoading";
import { StyledTableCell, StyledTableRow } from "../services/tableStyles";
import { isEngineer, isSuperAdmin, isAdmin } from "../services/authService";
import TerminalWindow from "./terminalWindow";

class CustomerEquipments extends FormComponent {
  state = {
    data: {
      name: "",
      sn: "",
      oltSlot: "",
      oltPort: "",
      ontId: "",
      ponOLTId: "",
      nasId: "",
      ipAcquisition: "",
      internetServicePort: "",
      userId: this.props.match.params.id,
    },
    sshOutput: "",
    billingCycleId: "",
    errors: {},
    billingCycles: [],
    equipments: [],
    nases: [],
    olts: [],
    pools: [],
    oltToActOn: {},
    equipmentNas: {},
    showAddModal: false,
    showChangeModal: false,
    showConfirmModal: false,
    showTerminalModal: false,
    showOltModal: false,
    oltProcessing: false,
    equipmentToActOn: {},
    loading: true,
    processing: false,
  };

  schema = {
    name: Joi.string().required().label("Name"),
    sn: Joi.string().required().label("Serial Number"),
    oltSlot: Joi.number().min(0).required().label("OLT Slot"),
    oltPort: Joi.number().min(0).max(15).required().label("OLT Port"),
    ontId: Joi.number().min(0).max(127).required().label("ONT ID"),
    ponOLTId: Joi.string().required().label("PON OLT"),
    nasId: Joi.string().required().label("NAS"),
    ipAcquisition: Joi.string().required().label("IP Acquisition"),
    internetServicePort: Joi.number().min(0).max(32767).required().label("Internet Service Port"),
    userId: Joi.string().required().label("User Id"),
  };

  doSubmit = async () => {
    this.setState({ processing: true });
    const { data: payload, equipments: originalEquipments } = this.state;

    try {
      const { data: newEquipment } = await addEquipment(payload);

      const equipments = [...originalEquipments];
      equipments.unshift(newEquipment);
      this.setState({ equipments, showAddModal: false });
      await this.populateEquipments();
      toast.success("Equipment Added");
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ processing: false });
  };

  async componentDidMount() {
    await this.populateEquipments();
    await this.populateNases();
    await this.populateBillingCycle();
  }

  async populateEquipments() {
    const { match } = this.props;
    const customerId = match.params.id;

    try {
      const { data: equipments } = await getCustomerEquipments(customerId);
      this.setState({ equipments });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
  }

  async populateNases() {
    try {
      const { data: routers } = await getRouters();
      
      const nases = routers.filter((r) => r.role === "NAS");
      this.setState({ nases });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
  }

  async populateBillingCycle() {
    try {
      const { data: billingCycles } = await getBillingCycles();
      this.setState({ billingCycles });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ loading: false });
  }

  async populatePonOLTs() {
    try {
      const { data: olts } = await getPonOLTsByRouter();
      this.setState({ olts });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
  }

  showConfirmModal = (equipmentToActOn) => {
    this.setState({ showConfirmModal: true, equipmentToActOn });
  };

  showOltModal = async (equipment) => {
    this.setState({ oltProcessing: true });
    try {
      const { data: oltToActOn } = await getPonOLTById(equipment.ponOLTId);

      const equipmentNas = this.state.nases.filter((nas) => nas._id === equipment.nasId);

      this.setState({ oltToActOn, equipmentNas: equipmentNas[0], equipmentToActOn: equipment });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }

    this.setState({ showOltModal: true, oltProcessing: false });
  };

  addOnt = async () => {
    this.setState({ oltProcessing: true });
    const payload = {
      host: this.state.oltToActOn.host,
      username: this.state.oltToActOn.username,
      password: this.state.oltToActOn.password,
      port: this.state.oltToActOn.sshPort,
      oltSlot: this.state.equipmentToActOn.oltSlot,
      oltPort: this.state.equipmentToActOn.oltPort,
      ontId: this.state.equipmentToActOn.ontId,
      internetServicePort: this.state.equipmentToActOn.internetServicePort,
      gemIndex: this.state.equipmentNas.oltGemIndex,
      vlanId: this.state.equipmentNas.oltVlan,
      equipmentId: this.state.equipmentToActOn._id,
      sn: this.state.equipmentToActOn.sn,
    };

    try {
      const { data: sshOutput } = await addOnt(payload);

      this.setState({ sshOutput });

      // const lowercasedOutput = sshOutput.toLowerCase();
      // if (!lowercasedOutput.includes("failure")) {
      // }
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }

    this.setState({ showTerminalModal: true, showOltModal: false, oltProcessing: false });
  };

  restartOnt = async () => {
    this.setState({ oltProcessing: true });
    const payload = {
      host: this.state.oltToActOn.host,
      username: this.state.oltToActOn.username,
      password: this.state.oltToActOn.password,
      port: this.state.oltToActOn.sshPort,
      oltSlot: this.state.equipmentToActOn.oltSlot,
      oltPort: this.state.equipmentToActOn.oltPort,
      ontId: this.state.equipmentToActOn.ontId,
    };

    try {
      const { data: sshOutput } = await restartOnt(payload);

      this.setState({ sshOutput });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }

    this.setState({ showTerminalModal: true, showOltModal: false, oltProcessing: false });
  };

  deleteOnt = async () => {
    this.setState({ oltProcessing: true });
    const payload = {
      host: this.state.oltToActOn.host,
      username: this.state.oltToActOn.username,
      password: this.state.oltToActOn.password,
      port: this.state.oltToActOn.sshPort,
      internetServicePort: this.state.equipmentToActOn.internetServicePort,
      oltSlot: this.state.equipmentToActOn.oltSlot,
      oltPort: this.state.equipmentToActOn.oltPort,
      ontId: this.state.equipmentToActOn.ontId,
    };

    try {
      const { data: sshOutput } = await deleteOnt(payload);

      this.setState({ sshOutput });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }

    this.setState({ showTerminalModal: true, showOltModal: false, oltProcessing: false });
  };

  getOntInfo = async (type) => {
    this.setState({ oltProcessing: true });
    const payload = {
      host: this.state.oltToActOn.host,
      username: this.state.oltToActOn.username,
      password: this.state.oltToActOn.password,
      port: this.state.oltToActOn.sshPort,
      oltSlot: this.state.equipmentToActOn.oltSlot,
      oltPort: this.state.equipmentToActOn.oltPort,
      ontId: this.state.equipmentToActOn.ontId,
    };

    try {
      let sshOutput = "";
      if (type === "optical") {
        const result = await getOntOpticalInfo(payload);
        sshOutput = result.data;
      } else if (type === "wan") {
        const result = await getOntWanInfo(payload);
        sshOutput = result.data;
      } else if (type === "general") {
        const result = await getOntInfo(payload);
        sshOutput = result.data;
      }

      this.setState({ sshOutput });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }

    this.setState({ showTerminalModal: true, showOltModal: false, oltProcessing: false });
  };

  handleShowAddModal = () => {
    this.setState({ showAddModal: true });
  };

  handleShowChangeModal = (equipmentToActOn) => {
    this.setState({ equipmentToActOn, showChangeModal: true });
  };

  handleSelectCycle = async (e) => {
    this.setState({ billingCycleId: e.currentTarget.value });
  };

  handleChangeCycle = async () => {
    this.setState({ processing: true });
    const { billingCycleId, equipmentToActOn } = this.state;

    try {
      await changeBillingCycle(equipmentToActOn._id, billingCycleId);

      this.setState({ showChangeModal: false });
      await this.populateEquipments();
      toast.success("Billing Cycle Changed");
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ processing: false });
  };

  handleClose = () => {
    this.setState({
      showAddModal: false,
      showChangeModal: false,
      showConfirmModal: false,
      showOltModal: false,
      showTerminalModal: false,
    });
  };

  handleSelectRouter = async (e) => {
    const nasId = e.currentTarget.value;

    if (nasId === "") {
      this.setState({ olts: [], pools: [], data: { userId: this.props.match.params.id } });
    } else {
      const newData = {...this.state.data, nasId}
      this.setState({ data: newData });
      await this.populatePonOLTs();
    }
  };

  handleDeleteEquipment = async () => {
    this.setState({ processing: true });
    const { equipmentToActOn, equipments: originalEquipments } = this.state;
    try {
      await deleteEquipment(equipmentToActOn._id);
      const equipments = originalEquipments.filter((e) => e._id !== equipmentToActOn._id);
      this.setState({ equipments, showConfirmModal: false });
      toast.success("Equipment Delete");
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ processing: false });
  };

  displayOntOpticalInfo = async () => {
    this.setState({ processing: true });
  };

  render() {
    const {
      sshOutput,
      equipments,
      equipmentToActOn,
      billingCycles,
      billingCycleId,
      nases,
      olts,
      oltToActOn,
      errors,
      data,
      oltProcessing,
      showOltModal,
      showAddModal,
      showChangeModal,
      showConfirmModal,
      showTerminalModal,
      loading,
      processing,
    } = this.state;

    return (
      <React.Fragment>
        {loading && <PageLoading loading={loading} />}
        {!loading && equipments.length === 0 && <span className="float-left mt-4">No Equipment to Display</span>}
        {!loading && (isEngineer() || isSuperAdmin()) && (
          <FloatingAddButton classes="float-right mt-2 mb-3" onClick={this.handleShowAddModal} />
        )}

        {!loading && equipments.length > 0 && (
          <TableContainer component={Paper}>
            <Table aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>Name</StyledTableCell>
                  <StyledTableCell>SN</StyledTableCell>
                  <StyledTableCell>OLT</StyledTableCell>
                  <StyledTableCell>F/S/P-ID/SP</StyledTableCell>
                  <StyledTableCell>Billing Cycle</StyledTableCell>
                  <StyledTableCell></StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {equipments.map((equipment) => (
                  <StyledTableRow key={equipment._id}>
                    <StyledTableCell>
                      <Link to={`/customers/${data.userId}/equipment/${equipment._id}`}>{equipment.name}</Link>
                    </StyledTableCell>
                    <StyledTableCell>{equipment.sn}</StyledTableCell>
                    <StyledTableCell>{equipment.olt}</StyledTableCell>
                    <StyledTableCell>
                      0/{equipment.oltSlot}/{equipment.oltPort} - {equipment.ontId}/{equipment.internetServicePort}
                    </StyledTableCell>
                    <StyledTableCell>{equipment.billingCycle}</StyledTableCell>

                    <StyledTableCell>
                      <DropdownButton className="mb-2" size="sm" id="dropdown-success-button" title="Actions">
                        {(isEngineer() || isSuperAdmin()) && (
                          <Dropdown.Item onClick={() => this.showOltModal(equipment)} disabled={oltProcessing}>
                            Terminal
                          </Dropdown.Item>
                        )}
                        {isAdmin && (
                          <Dropdown.Item
                            onClick={() =>
                              this.handleShowChangeModal({
                                _id: equipment._id,
                                name: equipment.name,
                                sn: equipment.sn,
                              })
                            }
                          >
                            Change Billing Cycle
                          </Dropdown.Item>
                        )}
                        <Dropdown.Divider />
                        {(isEngineer() || isSuperAdmin()) && (
                          <Dropdown.Item
                            onClick={() =>
                              this.showConfirmModal({
                                _id: equipment._id,
                                name: equipment.name,
                                sn: equipment.sn,
                              })
                            }
                          >
                            Delete
                          </Dropdown.Item>
                        )}
                      </DropdownButton>
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        <Modal show={showAddModal} size="lg" onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Add ONU</Modal.Title>
          </Modal.Header>
          <Form onSubmit={this.handleSubmit}>
            <Modal.Body>
                  <Form.Group controlId="nasId">
                    <Form.Label>NAS</Form.Label>
                    <Form.Control as="select" custom name="nasId" value={data.nasId} onChange={this.handleSelectRouter} size="sm" type="text">
                      <option value="">Select NAS</option>
                      {nases.map((router) => (
                        <option key={router._id} value={router._id}>
                          {router.name} ({router.host})
                        </option>
                      ))}
                    </Form.Control>
                    {errors.nasId && <span className="text-danger">{errors.nasId}</span>}
                  </Form.Group>
              
                  <Form.Group controlId="ponOLTId">
                    <Form.Label>Pon OLT</Form.Label>
                    <Form.Control
                      as="select"
                      custom
                      name="ponOLTId"
                      onChange={this.handleChange}
                      value={data.ponOLTId}
                      size="sm"
                      type="text"
                    >
                      <option value="">Select Pon OLT</option>
                      {olts.map((olt) => (
                        <option key={olt._id} value={olt._id}>
                          {olt.name} ({olt.host})
                        </option>
                      ))}
                    </Form.Control>
                    {errors.ponOLTId && <span className="text-danger">{errors.ponOLTId}</span>}
                  </Form.Group>

                  <Form.Group controlId="name">
                    <Form.Label>Name</Form.Label>
                    <Form.Control name="name" onChange={this.handleChange} value={data.name} size="sm" type="text" />
                    {errors.name && <span className="text-danger">{errors.name}</span>}
                  </Form.Group>

                  <Form.Group controlId="sn">
                    <Form.Label>S/N</Form.Label>
                    <Form.Control name="sn" onChange={this.handleChange} value={data.sn} size="sm" type="text" />
                    {errors.sn && <span className="text-danger">{errors.sn}</span>}
                  </Form.Group>

                  <Form.Group controlId="oltSlot">
                    <Form.Label>OLT Slot</Form.Label>
                    <Form.Control
                      name="oltSlot"
                      onChange={this.handleChange}
                      value={data.oltSlot}
                      size="sm"
                      type="text"
                    />
                    {errors.oltSlot && <span className="text-danger">{errors.oltSlot}</span>}
                  </Form.Group>

                  <Form.Group controlId="oltPort">
                    <Form.Label>OLT Port (0-15)</Form.Label>
                    <Form.Control
                      name="oltPort"
                      onChange={this.handleChange}
                      value={data.oltPort}
                      size="sm"
                      type="text"
                    />
                    {errors.oltPort && <span className="text-danger">{errors.oltPort}</span>}
                  </Form.Group>

                  <Form.Group controlId="ontId">
                    <Form.Label>ONT ID (0-127)</Form.Label>
                    <Form.Control name="ontId" onChange={this.handleChange} value={data.ontId} size="sm" type="text" />
                    {errors.ontId && <span className="text-danger">{errors.ontId}</span>}
                  </Form.Group>

                  <Form.Group controlId="internetServicePort">
                    <Form.Label>Internet Service Port (0-32767)</Form.Label>
                    <Form.Control
                      name="internetServicePort"
                      onChange={this.handleChange}
                      value={data.internetServicePort}
                      size="sm"
                      type="text"
                    />
                    {errors.internetServicePort && <span className="text-danger">{errors.internetServicePort}</span>}
                  </Form.Group>

                  <Form.Group controlId="ipAcquisition">
                    <Form.Label>Ip Acquisition</Form.Label>
                    <Form.Control as="select" name="ipAcquisition" value={data.ipAcquisition} onChange={this.handleChange}>
                      <option></option>
                      <option>Dynamic</option>
                      <option>Static</option>
                    </Form.Control>
                    {errors.type && <span className="text-danger">{errors.ipAcquisition}</span>}
                  </Form.Group>
              
            </Modal.Body>

            <Modal.Footer>
              <Button onClick={this.handleClose} variant="secondary">
                Close
              </Button>
              <Button disabled={this.validate() || processing} type="submit" variant="primary">
                {processing && (
                  <Spinner as="span" className="mr-2" animation="border" size="sm" role="status" aria-hidden="true" />
                )}
                Add
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>

        <Modal show={showChangeModal} size="sm" onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Change Billing Cycle</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <React.Fragment>
              <Form.Group controlId="billingCycleId">
                <Form.Control
                  as="select"
                  custom
                  name="billingCycleId"
                  onChange={this.handleSelectCycle}
                  value={billingCycleId}
                  size="sm"
                  type="text"
                >
                  <option value="">Select Cycle</option>
                  {billingCycles.map((billingCycle) => (
                    <option key={billingCycle._id} value={billingCycle._id}>
                      {billingCycle.cycleName}
                    </option>
                  ))}
                </Form.Control>
                {errors.billingCycleId && <span className="text-danger">{errors.billingCycleId}</span>}
              </Form.Group>
            </React.Fragment>
          </Modal.Body>

          <Modal.Footer>
            <Button onClick={this.handleClose} variant="secondary">
              Close
            </Button>
            <Button
              onClick={this.handleChangeCycle}
              disabled={billingCycleId === "" || processing}
              type="button"
              variant="primary"
            >
              {processing && (
                <Spinner as="span" className="mr-2" animation="border" size="sm" role="status" aria-hidden="true" />
              )}
              Change
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showConfirmModal} size="md" centered onHide={this.handleClose}>
          <Modal.Header closeButton className="bg-danger text-white">
            <Modal.Title>Delete Equipment</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to delete the equipment: {equipmentToActOn.name} ({equipmentToActOn.sn})?
            <br />
            <small className="text-danger">All the equipments's services will be deleted</small>
          </Modal.Body>

          <Modal.Footer>
            <Button onClick={this.handleClose} variant="secondary">
              No
            </Button>
            <Button disabled={processing} onClick={() => this.handleDeleteEquipment()} type="submit" variant="primary">
              {processing && (
                <Spinner as="span" className="mr-2" animation="border" size="sm" role="status" aria-hidden="true" />
              )}
              Yes
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal centered show={showOltModal} size="sm" onHide={this.handleClose}>
          {oltProcessing && (
            <center>
              <Spinner as="span" className="mr-2" animation="border" size="sm" role="status" aria-hidden="true" />
              <span>Processing command, please wait...</span>
            </center>
          )}
          <Modal.Body>
            <center>
              {equipmentToActOn.provisioningStatus === "new" && (
                <Button
                  size="lg"
                  className="mb-2"
                  disabled={oltProcessing}
                  onClick={() => this.addOnt()}
                  type="button"
                  variant="warning"
                >
                  Add ONT
                </Button>
              )}
              {equipmentToActOn.provisioningStatus === "edited" && (
                <Button size="lg" className="mb-3 mr-3" disabled={oltProcessing} type="button" variant="warning">
                  Update ONT
                </Button>
              )}
              {equipmentToActOn.provisioningStatus === "provisioned" && (
                <React.Fragment>
                  <Button
                    size="lg"
                    className="mb-3 mr-3"
                    disabled={oltProcessing}
                    onClick={() => this.restartOnt()}
                    type="button"
                    variant="warning"
                  >
                    Restart ONT
                  </Button>
                  <Button
                    size="lg"
                    className="mb-3"
                    disabled={oltProcessing}
                    onClick={() => this.getOntInfo("optical")}
                    type="button"
                    variant="warning"
                  >
                    Display ONT Optical Information
                  </Button>
                  <Button
                    size="lg"
                    className="mb-3"
                    disabled={oltProcessing}
                    onClick={() => this.getOntInfo("wan")}
                    type="button"
                    variant="warning"
                  >
                    Display ONT WAN Information
                  </Button>
                  <Button
                    size="lg"
                    className="mb-3"
                    disabled={oltProcessing}
                    onClick={() => this.getOntInfo("general")}
                    type="button"
                    variant="warning"
                  >
                    Display ONT Information
                  </Button>
                  <Button
                    size="lg"
                    className="mb-3"
                    disabled={oltProcessing}
                    onClick={() => this.deleteOnt()}
                    type="button"
                    variant="warning"
                  >
                    Delete ONT
                  </Button>
                </React.Fragment>
              )}
            </center>
          </Modal.Body>
        </Modal>

        <Modal
          centered
          className="terminalModalContainer"
          show={showTerminalModal}
          size="lg"
          scrollable={true}
          onHide={this.handleClose}
        >
          <Modal.Body className="terminalModal">
            <TerminalWindow title={oltToActOn.model} output={sshOutput} />
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}

export default CustomerEquipments;
